/* eslint-disable no-return-assign */
import { setOverviewId } from "action/utils/setOverviewId";
import { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import LinkCard from "component/link-card/LinkCard";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { Component } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PRODUCT_PAGE_TYPES } from "util/product/product-constants";
import HideIf from "../../../../util/HideIf";
import OverviewHeaderMobile from "./OverviewHeaderMobile";
import styles from "./styles.module.scss";

const setInTransition = (innerRefScrollHeight: any) => innerRefScrollHeight !== 0;

/**
 * most of the code for collapsible took from
 * https://github.com/glennflanagan/react-collapsible/
 */
class OverviewItem extends Component {
  innerRef: any;

  timeout: any;

  userAction: any;

  constructor(props: any) {
    super(props);
    this.userAction = false;
    this.timeout = undefined;

    // Defaults the dropdown to be closed
    if (props.open) {
      this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: "auto",
        transition: "none",
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false,
      };
    } else {
      this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: `height ${props.transitionTime}ms ${props.easing}`,
        hasBeenOpened: false,
        overflow: "hidden",
        inTransition: false,
      };
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.utils.overviewId !== this.props.utils.overviewId && nextProps.utils.overviewId && window.innerWidth < 768) {
      this.handleTriggerClick(null, nextProps.utils.overviewId);
    }
    if (nextProps.id === "FITTINGVEHICLE" && nextProps.router?.asPath !== this.props.router?.asPath) {
      this.setState({
        height: 0,
        overflow: "hidden",
        hasBeenOpened: false,
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
      });
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.shouldOpenOnNextCycle) {
      this.continueOpenCollapsible();
    }

    if (
      (prevState.height === "auto" || prevState.height === 0)

      && this.state.shouldSwitchAutoOnNextCycle === true
    ) {
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => {
        // Set small timeout to ensure a true re-render
        this.setState({
          height: 0,
          overflow: "hidden",
          isClosed: true,
          shouldSwitchAutoOnNextCycle: false,
        });
      }, 50);
    }

    // If there has been a change in the open prop (controlled by accordion)

    if (prevProps.open !== this.props.open) {
      if (this.props.open === true) {
        this.openCollapsible();

        this.props.onOpening();
      } else {
        this.closeCollapsible();

        this.props.onClosing();
      }
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  closeCollapsible() {
    const { innerRef } = this;

    this.setState({
      shouldSwitchAutoOnNextCycle: true,
      height: innerRef.scrollHeight,
      transition: `height ${

        this.props.transitionCloseTime

          ? this.props.transitionCloseTime

          : this.props.transitionTime

      }ms ${this.props.easing}`,
      inTransition: setInTransition(innerRef.scrollHeight),
    });
  }

  openCollapsible() {
    this.setState({
      inTransition: setInTransition(this.innerRef.scrollHeight),
      shouldOpenOnNextCycle: true,
    });
  }

  continueOpenCollapsible = () => {
    const { innerRef } = this;

    this.setState({
      height: innerRef.scrollHeight,
      transition: `height ${this.props.transitionTime}ms ${this.props.easing}`,
      isClosed: false,
      hasBeenOpened: true,
      inTransition: setInTransition(innerRef.scrollHeight),
      shouldOpenOnNextCycle: false,
    });
  };

  handleTriggerClick = (event: any, nextOverviewId: string) => {
    if (this.props.triggerDisabled || this.state.inTransition) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    // separate logic for mobile bcz it is handled via redux
    if (window.innerWidth < 768) {
      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else if (nextOverviewId) {
        this.props.dispatch(setOverviewId(nextOverviewId));
        this.userAction = true;
        this.openCollapsible();

        this.props.onOpening();

        this.props.onTriggerOpening();
      } else {
        this.closeCollapsible();

        this.props.onClosing(nextOverviewId);

        this.props.onTriggerClosing();
        this.props.dispatch(setOverviewId(""));
      }
    } else if (this.props.handleTriggerClick) {
      this.props.handleTriggerClick(this.props.accordionPosition);
    } else if (this.state.isClosed === true || (this.userAction === false && window.innerWidth < 768)) {
      if (window.innerWidth < 768) {
        this.props.dispatch(setOverviewId(nextOverviewId || this.props.id));
      }
      this.userAction = true;
      this.openCollapsible();

      this.props.onOpening();

      this.props.onTriggerOpening();
    } else {
      console.log("else");
      this.closeCollapsible();

      this.props.onClosing(this.props.id);

      this.props.onTriggerClosing();
      this.props.dispatch(setOverviewId(""));
    }
  };

  handleTransitionEnd = (e: any) => {
    // only handle transitions that origin from the container of this component
    if (e.target !== this.innerRef) {
      return;
    }
    // Switch to height auto to make the container responsive

    if (!this.state.isClosed) {
      this.setState({
        height: "auto",

        overflow: this.props.overflowWhenOpen,
        inTransition: false,
      });

      this.props.onOpen();
    } else {
      this.setState({ inTransition: false });

      this.props.onClose();
    }
  };

  setInnerRef = (ref: any) => this.innerRef = ref;

  render() {
    const dropdownStyle = {

      height: this.state.height,

      WebkitTransition: this.state.transition,

      msTransition: this.state.transition,

      transition: this.state.transition,

      overflow: this.state.overflow,
      marginTop: "calc(-0.4 * var(--safari-root-font, 10px))",
    };

    // Don't render children until the first opening of the Collapsible if lazy rendering is enabled

    const children = this.props.lazyRender

      && !this.state.hasBeenOpened

      && this.state.isClosed

      && !this.state.inTransition
      ? null
      : this.props.children;

    const {

      id, title, subTitle, thumbnail, description, price, rating, maximumPrice,

      minimumPrice, hideMobileHeader = false, getThumbImagePath, product,

      staticContent, handleAddToCart, productHighlights, imageTitle,
    } = this.props;

    const { currentPageType } = this.props.utils;

    const overviewProps = {
      thumbnail,
      description,
      price,
      rating,
      maximumPrice,
      minimumPrice,
      id,
      title,
      subTitle,
      hideMobileHeader,
      getThumbImagePath,
      productHighlights,
      imageTitle,
    };

    const openClass = this.state.isClosed;
    const { overviewId } = this.props.utils;
    // don't show stiejabber reviews on mobile's collapsible
    const notShowOnDesktop = Boolean(process.browser && window.innerWidth < 768 && id === "REVIEWS");

    return (

      <div id={id} className={`${styles.overview_item} ${this.props.className}`}>

        <HideIf show={id !== "ZOOMIMAGEPOPUP"}>

          <LinkCard
            {...{ id, title, subTitle }}
            onClick={(e) => this.handleTriggerClick(e, this.props.id)}
            openClass={!openClass}
            fontSize={FONT_SIZE[1]}
          />
        </HideIf>
        {/* this will make sure that OverviewHeaderMobile will open when users clicks on it */}
        {/** if open props is set set to true, then content is also present on mobile DOM, but OverviewHeaderMobile will open
          *  only when user clicks on it.
          */
        }
        {

          overviewId === this.props.id && this.userAction && process.browser && window.innerWidth < 768 && (
            <OverviewHeaderMobile
              className={styles.overview_modal_content}
              {...overviewProps}
              show
              handleExpandClose={this.handleTriggerClick}
              product={product}
              staticContent={staticContent}
              showAddtoCart={overviewId === "OVERVIEW" && PRODUCT_PAGE_TYPES.includes(currentPageType)}
              handleAddToCart={handleAddToCart}
            >
              {children}
            </OverviewHeaderMobile>
          )
        }

        <div
          className={`${styles.Collapsible__contentOuter}`}
          style={dropdownStyle}
          onTransitionEnd={this.handleTransitionEnd}
          ref={this.setInnerRef}
          data-testid="collapsible-outer"
        >

          { !notShowOnDesktop ? <div className={styles.Collapsible__contentInner} data-testid="collapsible-inner">{children}</div> : null}
        </div>
      </div>
    );
  }
}

OverviewItem.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  easing: "linear",
  open: false,
  triggerDisabled: false,
  lazyRender: true,
  overflowWhenOpen: "hidden",
  contentHiddenWhenClosed: false,
  openedClassName: "",
  className: "",
  onOpen: () => {},
  onClose: () => {},
  onOpening: () => {},
  onClosing: () => {},
  onTriggerOpening: () => {},
  onTriggerClosing: () => {},
};

const OverviewItemWithRouter = (props) => {
  const router = useRouter();
  const utils = useSelector((store: RootState) => store.utils);
  const dispatch = useDispatch();
  return (
    <OverviewItem
      {...props}
      router={router}
      utils={utils}
      dispatch={dispatch}
    />
  );
};

export default OverviewItemWithRouter;
